/* istanbul ignore file */
// eslint-disable-next-line no-shadow
enum StatesEnum {
  // common states
  INITIALIZED = 'initialized',
  WELCOME_PAGE_FINISHED = 'welcome_page_finished',
  PERSONAL_DATA_FORM = 'personal_data_form',
  BACKGROUND_CHECK_APPROVED = 'background_check_approved',
  BACKGROUND_CHECK_DISAPPROVED = 'background_check_disapproved',
  AWAITING_CONTRACT_SIGNATURE = 'awaiting_contract_signature',
  EDUCATION_CONTRACT_SIGNED = 'education_contract_signed',
  FINANCING_CONTRACT_SIGNED = 'financing_contract_signed',
  FINANCING_GRANTED = 'financing_granted',
  // v2
  GUARANTOR_REGISTRATION = 'guarantor_registration',
  REGISTER_GUARANTOR = 'register_guarantor',
  FIRST_GUARANTOR_REGISTRATION_FORM = 'first_guarantor_registration_form',
  SECOND_GUARANTOR_REGISTRATION_FORM = 'second_guarantor_registration_form',
  GUARANTOR_REGISTRATION_COMPLETED = 'guarantor_registration_completed',
  DISAPPROVED = 'guarantors_disapproved',
  CHANGE_PAYMENT_METHOD = 'change_payment_method',
  FINISH_FINANCING_REQUEST = 'finish_financing_request',
  BACKGROUND_CHECK = 'background_check',
  GIVE_UP_FINANCING = 'give_up_financing',
  // v3
  SCORE_GUARANTOR_REGISTRATION = 'score_guarantor_registration',
  SCORE_REGISTRATION_COMPLETED = 'score_registration_completed',
  SCORE_BACKGROUND_CHECK = 'score_background_check',
  SCORE_DISAPPROVED = 'score_disapproved',
  CHANGE_FINANCING_TYPE = 'change_financing_type',
  FIRST_GUARANTOR_REGISTRATION = 'first_guarantor_registration',
  SECOND_GUARANTOR_REGISTRATION = 'second_guarantor_registration',
  GIVE_UP_SCORE_CHECK = 'give_up_score_check',
  CREDIT_REGISTRATION_COMPLETED = 'credit_registration_completed',
  CREDIT_BACKGROUND_CHECK = 'credit_background_check',
  CREDIT_DISAPPROVED = 'credit_disapproved',
}

export default StatesEnum;
